import React, { useState, useRef, useEffect } from "react";
import "../../assets/styles/visits.scss";
import { convertToNameLabel, mask } from "../../utils/utils";
import { useParams } from "react-router-dom";
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import ProfileView from '../../components/common/profileView';
import { useSelector } from "react-redux";
import PreTreatmentReport from "./PreTreatmentReports";
import PostTreatmentReport from "./PostTreatmentReports";
import ListTabView from '../../components/common/tabView';
import TabHeaderView from '../../components/common/tabHeaderView';
import Spec from "../../assets/images/spec";

const DoctorTreatmentReport = () => {
  const containerRef = useRef();
  const camp_id = useSelector((state) => state.common.camp?.camp_details_id);
  const [patient, setPatient] = useState({});
  const [profileLoading, setProfileLoading] = useState({});
  const { id } = useParams();

  const init = async (refresh) => {
    !refresh && setProfileLoading(true);

    try {
      const { data = {} } = await commonPostApi(API_ENDPOINTS.SEARCH_PATIENT_DETAILS, {
        patient_id: id,
      });

      const patientDetails = data?.patient;
      patientDetails.aarogyasri_no = patientDetails["health_insurance_card"];
      patientDetails.aadhaar_no = patientDetails["aadhar_no"];
      const finalList = {};
      [
        "patient_code",
        "gender",
        "dob",
        "aadhaar_no",
        "aarogyasri_no",
        "ration_card_no",
        "address",
      ].forEach((item) => {
        if (item === "patient_code") {
          finalList["patient_iD"] = patientDetails[item];
        } else {
          finalList[item] = patientDetails[item];
        }
      });

      let finalData = convertToNameLabel(finalList, [
        "patient_name",
        "first_name",
        "last_name",
        "profile_picture",
        "district",
        "state",
        "city",
        "pincode",
        "phone_no",
        "updated_by",
        "created_at",
        "created_by",
        "updated_at",
      ]);
      finalData.name = patientDetails["patient_name"];
      finalData.imgUrl = patientDetails?.profile_picture
        ? `${process.env?.REACT_APP_CURRENT_URL}${API_ENDPOINTS.SEARCH_IMAGE_BY_ID(patientDetails?.patient_id)}`
        : null;
      finalData = Object.entries(finalData)
        .map(([label, value]) => {
          if (
            value?.value &&
            ["aadhaar_no", "aarogyasri_no", "ration_card_no"].includes(label)
          ) {
            return { [label]: { ...value, value: mask(value?.value) } };
          } else {
            return { [label]: value };
          }
        })
        ?.reduce((acc, item) => {
          const normalizedItem =
            Array.isArray(item) && item.length === 1 ? item[0] : item;
          return { ...acc, ...normalizedItem };
        }, {});

      setPatient({ finalData, originalData: patientDetails });
      setProfileLoading(false);
    } catch (err) {
      console.log(err);
      setProfileLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, [camp_id]);

  return (
    <div className="Visits__container">
      <ProfileView
        profile={patient?.finalData}
        loading={profileLoading}
        parentClass={"ml-auto"}
      />

      <div ref={containerRef}>
        <div className="report-buttons">
          <button className="btn btn-primary">
            <i className="pi pi-download"></i> Download
          </button>
          <button className="btn btn-secondary">
            <i className="pi pi-print"></i> Print
          </button>
          <button className="btn btn-primary">
            <i className="pi pi-upload"></i> Share
          </button>
        </div>

        <ListTabView
          index={1}
          tabClass={"payement-details-tab"}
          defaultIndex={0}
          listComponent={[
            {
              header: (
                <TabHeaderView
                  iconHtml={
                    <span className="pr-2">
                      <Spec />
                    </span>
                  }
                  title={"Pre Treatment Report"}
                />
              ),
              content: <PreTreatmentReport id={id} />,
            },
            {
              header: (
                <TabHeaderView
                  iconHtml={
                    <span className="pr-2">
                      <Spec />
                    </span>
                  }
                  title={"Post Treatment Report"}
                />
              ),
              content: <PostTreatmentReport id={id} />,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default DoctorTreatmentReport;
